export const pluralize = (count: number, singular: string, plural: string) =>
  `${count} ${count === 1 ? singular : plural}`;

const DIACRITICS_REGEX = new RegExp('[\\u0300-\\u036f]', 'g');

/** Texto sem acentos e em minusculas, para comparacao na busca local. */
export const normalizeText = (value: string) =>
  (value || '')
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .toLowerCase()
    .trim();
